module.exports = __webpack_public_path__ + "28e811b1dd4da5a2a092262ee9afcfa7.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsolutions/assets/13-Betsolutions-Seka.png
// module id = 1735
// module chunks = 2